/**
 * Форматирование моментов API (RFC3339, UTC) в календарной таймзоне организации.
 * Если timezone пустая/невалидная — fallback на локаль браузера.
 */

function orgTimezoneOrDefault(tz?: string | null): string | undefined {
  const t = String(tz ?? '').trim();
  if (!t) return undefined;
  try {
    // Проверка IANA-зоны (intl бросит исключение на невалидной).
    Intl.DateTimeFormat(undefined, { timeZone: t });
    return t;
  } catch {
    return undefined;
  }
}

function parseIso(iso: string | null | undefined): Date | null {
  if (iso == null || !String(iso).trim()) return null;
  const d = new Date(String(iso).trim());
  return Number.isNaN(d.getTime()) ? null : d;
}

function optionsTz(tz: string | undefined): Intl.DateTimeFormatOptions {
  return tz ? { timeZone: tz } : {};
}

/** ДД.ММ.ГГГГ ЧЧ:ММ в таймзоне org; null/битый вход → '—'. */
export function formatOrgDateTime(iso: string | null | undefined, timezone?: string | null): string {
  const d = parseIso(iso);
  if (!d) return '—';
  const tz = orgTimezoneOrDefault(timezone);
  return new Intl.DateTimeFormat('ru-RU', {
    ...optionsTz(tz),
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(d);
}

/** ДД.ММ.ГГГГ в таймзоне org; null/битый вход → '—'. */
export function formatOrgDate(iso: string | null | undefined, timezone?: string | null): string {
  const d = parseIso(iso);
  if (!d) return '—';
  const tz = orgTimezoneOrDefault(timezone);
  return new Intl.DateTimeFormat('ru-RU', {
    ...optionsTz(tz),
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(d);
}

/** ЧЧ:ММ в таймзоне org; null/битый вход → '—'. */
export function formatOrgTime(iso: string | null | undefined, timezone?: string | null): string {
  const d = parseIso(iso);
  if (!d) return '—';
  const tz = orgTimezoneOrDefault(timezone);
  return new Intl.DateTimeFormat('ru-RU', {
    ...optionsTz(tz),
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(d);
}

/** ДД.ММ.ГГГГ ЧЧ:ММ:СС в таймзоне org (журналы аудита). */
export function formatOrgDateTimeSeconds(iso: string | null | undefined, timezone?: string | null): string {
  const d = parseIso(iso);
  if (!d) return '—';
  const tz = orgTimezoneOrDefault(timezone);
  return new Intl.DateTimeFormat('ru-RU', {
    ...optionsTz(tz),
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(d);
}